import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-info-capture',
  templateUrl: './info-capture.component.html',
  styleUrls: ['./info-capture.component.css']
})
export class InfoCaptureComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
